import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool, utils_tool } from "@/tool";
import columns from "./columns";
import { WizTableForm } from "@/containers/common";
import { CloseOutlined } from '@ant-design/icons';
import { AudienceGroupItem } from '@/components';
import './index.less'

const { WizContainer, modelUtils } = framework_tool;
const { WizRow, WizCol, WizDataTable, WizButton, WizModal, WizDropdown, WizMenu, WizIcon } = component_tool;
const exam = WizTableForm.Config.exam(this, { apiParams: { status: 1 } })
const program = WizTableForm.Config.program(this, { apiParams: { isPower: true, status: 1 } })
const offlineProgram = WizTableForm.Config.offlineProgram(this, { apiParams: { status: 1 } })
// const survey = WizTableForm.Config.survey(this, { apiParams: {} })
const pathStage = WizTableForm.Config.pathStage(this, { apiParams: { state: 2 } })
const homeworkConfig = WizTableForm.Config.homework(this, { apiParams: { state: 1 } });
// const applyConfig = WizTableForm.Config.apply(this, { apiParams: { state: 1 } });

const { getPageData } = utils_tool

class WizPreconditions extends WizContainer {
  componentName = "WizPreconditions";

  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      records: [],
      selectedRows: [],
      activeKey: '0',
      locType: '',
      andOrList: [0, 0, 0, 0, 0],
      locAuthData: {},
      authVisible: false,
    };

    this.config = [
      { key: 0, title: '课程', ...program },
      { key: 1, title: '考试', ...exam },
      // { key: 2, title: '问卷', ...survey },
      { key: 8, title: '培训主题', ...offlineProgram },
      { key: 12, title: '培训路径', ...pathStage },
      { key: 30, title: '作业', ...homeworkConfig },
      // { key: 15, title: '报名', ...applyConfig },
    ]
  }

  getData = () => {
    const { bizType, bizId } = this.props

    this.doAction({
      path: "beforeCondition/list",
      payload: {
        key: "beforeCondition@list",
        apiParams: { bizType: 58, bizId },
      },
    });
  }

  _componentDidMount() {
    this.getData()
  }

  // 监听属性和状态的变化
  propsAndStateOnChange = {
    list: this._list.bind(this),
    save: this._save.bind(this),
    saveToNext: this._saveToNext.bind(this),
    authInfo: this._authInfo.bind(this),
  };
  _saveToNext(nextProps, nextState) {
    const { saveToNext } = nextProps;
    if (saveToNext > 0) {
      this.handleSubmit()
      return true;
    }
  }
  _authInfo(nextProps, nextState) {
    const { authInfo } = nextProps;
    if (authInfo.success) {
      const data = authInfo.data || {}
      nextState.locAuthData = data
      nextState.authVisible = true
      return true;
    }
    wizNotice.error(authInfo.msg)
    return false;
  }
  _list(nextProps, nextState) {
    const { list, addChecked } = nextProps;
    if (list.success) {
      const data = list.data || {}
      let groupArr = [0, 0, 0, 0, 0]
      const _records = this._formatData(data.conditionList, data.conditionGroupList)
      let arr = []
      _records.forEach((item, index) => {
        groupArr[index] = item.conditionType
        item.children?.length > 0 && item.children.forEach(cItem => {
          arr.push(cItem)
        })
      })
      let checked = []
      arr.forEach(item => {
        if (checked.findIndex(x => x == item) == -1) {
          checked.push(item.conditionBizType)
        }
      })
      addChecked([...new Set(checked)])
      nextState.records = JSON.parse(JSON.stringify(arr))
      nextState.andOrList = groupArr
      return true;
    }
    wizNotice.error(list.msg)
    return false;
  }
  delChecked = (item) => {
    let { addChecked } = this.props
    let checkArr = [...this.props.checkArr]
    checkArr = checkArr.filter(x => x != item)
    addChecked(checkArr)
  }
  _save(nextProps, nextState) {
    const { save, jumpNext, nextOrBack, jumpBack } = nextProps;
    if (save.success) {
      wizNotice.success(save.msg)
      if (nextOrBack) {
        jumpNext()
      } else {
        jumpBack()
      }
      this.getData()
      return true;
    }
    wizNotice.error(save.msg)
    return false;
  }
  closeVisible = () => {
    this.setState({ authVisible: false })
  }

  _formatData = (conditionList = [], conditionGroupList = []) => {
    return conditionList.map(val => ({
      ...val,
      isGroup: false,
    })).concat(conditionGroupList.map((val, index) => ({
      ...val,
      isGroup: true,
      children: val.children && val.children.length ? val.children.map(val => ({ ...val, pIndex: conditionList.length + index })) : undefined
    })))
  }
  getItemAuth = (record) => {
    this.doAction({
      path: "whitelist/authInfo",
      payload: {
        key: "whitelist@authInfo",
        apiParams: { bizType: record.conditionBizType, bizId: record.conditionBizId },
      },
    });

  }
  formatRecords = (records) => {
    const _records = JSON.parse(JSON.stringify(records))
    const conditionList = _records.filter(val => !val.isGroup)
    const conditionGroupList = _records.filter(val => val.isGroup)
    const formatRecords = this._formatData(conditionList, conditionGroupList)

    return formatRecords
  }

  // 添加条件
  handleAddCondition = (item, index) => {
    this.setState({ visible: true, index: index, activeKey: '0', locType: item })
  }

  // 添加条件组
  handleAddConditionGroup = key => {
    const { records } = this.state
    const _records = JSON.parse(JSON.stringify(records))

    _records.push({
      isGroup: true,
      conditionType: 0,
      conditionBizId: new Date().getTime(),
      // conditionBizType: Number(key),
      rowId: new Date().getTime(),
    })

    this.setState({ records: this.formatRecords(_records) })
  }

  // 删除
  handleDelete = ({ conditionBizId }) => {
    const { records } = this.state
    const _records = JSON.parse(JSON.stringify(records))
    _records.forEach((item, index) => {
      if (item.conditionBizId == conditionBizId) {
        _records.splice(index, 1)
      }
    })
    this.setState({ records: this.formatRecords(_records) })
  }

  // 提交
  handleSubmit = () => {
    const { bizType, bizId, checkArr } = this.props
    const { records, andOrList } = this.state
    const conditionList = records.filter(val => !val.isGroup)
    // conditionList.map(item=> {return item.conditionBizType=type})
    // const conditionGroupList = records.filter(val => val.isGroup)
    const conditionGroupList = []

    checkArr.forEach((item, index) => {
      conditionGroupList.push(
        {
          isGroup: true,
          conditionType: andOrList[index],
          conditionBizId: new Date().getTime() + item,
          // conditionBizType: item,
          rowId: new Date().getTime() + item,
          type: item,
          children: conditionList.filter(x => x.conditionBizType == item)
        }
      )
    })

    const _index = conditionGroupList.findIndex(val => val.children && !val.children.length)

    if (_index !== -1) {
      wizNotice.error(`已勾选的业务类型内容不能为空`)
      return
    }
    this.doAction({
      path: "beforeCondition/save",
      payload: {
        key: "beforeCondition@save",
        apiParams: {
          bizType: 58,
          bizId,
          conditionList: [],
          conditionGroupList
        }
      }
    })
  }

  // 重置
  handleReset = () => {
    const { list } = this.props;
    const data = list.data || {}
    const records = this._formatData(data.conditionList, data.conditionGroupList)
    this.setState({ records })
  }
  // 组之间选择或和与
  handleGroupSelectConditionType = (index, flag, pIndex) => {
    let andOrList = [...this.state.andOrList]
    andOrList[index] = flag
    this.setState({ andOrList: andOrList })
  }
  // 选择或和与
  handleSelectConditionType = (record, flag, pIndex) => {
    const { records } = this.state
    const _records = JSON.parse(JSON.stringify(records))
    // if (pIndex !== undefined) {
    //   _records[pIndex].children[index].conditionType = flag
    // } else {
    _records.forEach((item, i) => {
      if (item.conditionBizId == record.conditionBizId) {
        _records[i].conditionType = flag
      }
    })
    // }
    this.setState({ records: _records })
  }
  // 选择通过与未通过
  handleSelectPassThrough = (record, flag, pIndex) => {
    const { records } = this.state
    const _records = JSON.parse(JSON.stringify(records))
    _records.forEach((item, i) => {
      if (item.conditionBizId == record.conditionBizId) {
        _records[i].conditionActionType = flag
      }
    })
    // if (pIndex !== undefined) {
    //   _records[pIndex].children[index].conditionActionType = flag
    // } else {
    // }
    this.setState({ records: _records })
  }
  // 格式化选择行的数据
  formatSelectedRows = (selectedRows, pIndex, locType) => {
    const { activeKey } = this.state
    return selectedRows.map(val => ({
      authData: val.authData,
      isGroup: false,
      conditionType: 0,
      conditionBizType: locType,
      conditionBizId: val.id,
      conditionBizName: val.name || val.title,
      trainPathName: val.trainPathName,
      rowId: new Date().getTime() + 'rowId' + val.id,
      pIndex,
      conditionActionType: 1,
      type: locType
    }))
  }

  // 弹出条件数据表格选择行
  onSelectedRows = selectedRows => {
    this.setState({ selectedRows })
  }

  // 弹出条件数据表格tab切换
  handleTabOnChange = (activeKey) => {
    this.setState({ activeKey })
  }

  conditionExtraChange = (record, value) => {
    record.conditionExtra = value
    let { records } = this.state
    if (records && Array.isArray(records) && records.length) {
      records.forEach(item => {
        if (item.rowId == record.rowId) {
          item = record
        }
      })
    }
  }
  // 弹出条件数据表格确认按钮
  onOk = () => {
    const { selectedRows, records, index, locType } = this.state
    if (!selectedRows.length) {
      wizNotice.warn('请选择一行数据')
      return
    }
    const _formatSelectedRows = this.formatSelectedRows(selectedRows, index, locType)
    // if (index !== undefined) {
    // const children = records[index]?.children || []
    // // records[index].children = uniqBy([...children, ..._formatSelectedRows], 'rowId')
    // records[index].children = [...children, ..._formatSelectedRows]

    // this.setState({ visible: false, records: this.formatRecords(records) })
    // } else {
    // const _filter = uniqBy([ ..._formatSelectedRows, ...records ], 'rowId')
    const _filter = [...records, ..._formatSelectedRows]

    this.setState({ visible: false, records: this.formatRecords(_filter) })
    // }
  }

  // 弹出条件数据表格取消按钮
  onCancel = () => {
    this.setState({ visible: false, activeKey: '0' })
  }

  _render() {
    const { visible, records, activeKey, locType, locAuthData, authVisible } = this.state
    let { beforeConditionLoading, checkArr, bizType } = this.props
    const dataItems = getPageData({ records })
    const formatDataItems = (item) => {
      let items = { ...dataItems }
      let list = dataItems.list.filter(x => x.conditionBizType == item)
      items.list = list
      return items
    }

    const conditionBizList = records.reduce((acc, curr) => {  
      acc[curr.conditionBizType].push(curr.conditionBizId);  
      return acc;  
    }, {  
      0: [],  
      1: [],  
      8: [],  
      12: [],  
      30: [],  
    });  

    const dataTableProps = {
      key: new Date(),
      loading: beforeConditionLoading,
      style: { marginTop: 15, minHeight: 150 },
      rowKey: 'rowId',
      isScroll: true,
      defaultExpandAllRows: true,
    }
    const modalProps = {
      visible,
      width: 1000,
      onOk: this.onOk,
      onCancel: this.onCancel,
      style: { top: 30 }
    }
    const menu = (index, pIndex) => (
      <WizMenu>
        <WizMenu.Item onClick={() => this.handleGroupSelectConditionType(index + 1, 0, pIndex + 1)}>与</WizMenu.Item>
        <WizMenu.Item onClick={() => this.handleGroupSelectConditionType(index + 1, 1, pIndex + 1)}>或</WizMenu.Item>
      </WizMenu>
    );
    renderItem = (item, index, checkArr) => {
      let title = ''
      let btnText = ''
      if (item == 0) {
        title = '在线课程'
        btnText = '添加课程'
      } else if (item == 8) {
        title = '培训主题'
        btnText = '添加班级'
      } else if (item == 1) {
        title = '考试'
        btnText = '添加考试'
      } else if (item == 30) {
        title = '作业'
        btnText = '添加作业'
      } else if (item == 12) {
        title = '路径'
        btnText = '添加路径'
      }

      return (
        <div className="preconditions-item-out-box" >
          <div className="preconditions-item-inner-box">
            <div className='title-box'>
              <div>{title}</div>
              <div><CloseOutlined onClick={() => { this.delChecked(item) }} /></div>
            </div>
            <div className='content-box'>
              <WizRow type="flex" align="middle">
                <WizCol span={24}>
                  <WizButton type="primary" style={{ marginRight: 15 }} onClick={() => this.handleAddCondition(item, index)} ghost>{btnText}</WizButton>
                </WizCol>
              </WizRow>
              <WizDataTable {...dataTableProps} dataItems={formatDataItems(item)} columns={columns.call(this, activeKey, formatDataItems(item), item, locAuthData, authVisible)} />
            </div>
            {checkArr.length - 1 == index ?
              null :
              <div className="and-or-out">
                <div className="and-or-inner">
                  <WizDropdown overlay={menu(index, index)}><a> {formatAndOr(index)} <WizIcon type='down' /></a></WizDropdown>
                </div>
              </div>}
          </div>
        </div>
      )
    }
    formatAndOr = (index) => {
      let { andOrList } = this.state
      if (andOrList[index + 1] == 0) {
        return '与'
      } else {
        return '或'

      }
    }

    // const menu = (
    //   <WizMenu>
    //     { this.config.map(val => <WizMenu.Item key={val.key} onClick={() => this.handleAddConditionGroup(val.key)}>{val.title}</WizMenu.Item>) }
    //   </WizMenu>
    // );

 const tableProps = (conditionBizIds) => {
  return {
    needOnRowSelect: (record) => {
      let disabled = conditionBizIds.indexOf(record.id) !== -1
      return !disabled
    },
    rowSelection: {
      getCheckboxProps: (record) => {
          let disabled = conditionBizIds.indexOf(record.id) !== -1
          return { disabled };
      },
  },
  }
}

    return (
      <React.Fragment>
        {checkArr.map((item, index) => {
          return (
            <>
              {renderItem(item, index, checkArr)}
            </>
          )
        })}
        {visible ? <WizModal {...modalProps} className='label-modal-box'>
          {this.config.map((val, index) => {
            return (
              <>
                {val.key == locType ?
                  <WizTableForm key={val.key} 
                                showModal={false} 
                                {...val} 
                                onSelectedRows={this.onSelectedRows} 
                                tableProps={tableProps(conditionBizList[locType])}
                  />
                  : null}
              </>
            )
          }
          )}
        </WizModal> : null}
        <WizModal title='查看受众' width={700} visible={authVisible} footer={null}
          onCancel={() => this.setState({ authVisible: false })}>
          <AudienceGroupItem {...locAuthData} />
        </WizModal>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { beforeCondition, whitelist } = state;
  const list = modelUtils.getModelEntity(beforeCondition, 'beforeCondition@list');
  const save = modelUtils.getModelEntity(beforeCondition, 'beforeCondition@save');
  const authInfo = modelUtils.getModelEntity(whitelist, 'whitelist@authInfo');

  // const del = modelUtils.getModelEntity(beforeCondition,'beforeCondition@del');

  const load = modelUtils.getLoadingState(state, "beforeCondition");

  return {
    list,
    save,
    authInfo,
    // del,
    ...load,
  };
};

export default connect(mapStateToProps)(WizPreconditions);
